module.exports = __webpack_public_path__ + "img/2014.df876016.png";